import { render, staticRenderFns } from "./ClientSearchAreaStorageAdjust.vue?vue&type=template&id=0df68dc9&scoped=true&"
import script from "./ClientSearchAreaStorageAdjust.vue?vue&type=script&lang=js&"
export * from "./ClientSearchAreaStorageAdjust.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchAreaStorageAdjust.vue?vue&type=style&index=0&id=0df68dc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df68dc9",
  null
  
)

export default component.exports